export const ROLE_LABELS = {
  SuperAdmin:       'Super Admin',
  Admin:            'Admin',
  Lecturer:         'Lecturer',
  Registrar:  'Registrar',
  FinanceOfficer:   'Finance Officer',
  HR_Officer:       'HR Officer',
  Receptionist:     'Receptionist',
  ProgrammeManager: 'Programme Manager',
  Student:          'Student',
  CEO:              'CEO',
  Founder:          'Founder',
  Principal:        'Principal',
  HeadTeacher:      'Head Lecturer',
  Teacher:          'Lecturer',
  BoardingOfficer:  'Boarding Officer',
  AdmissionsOfficer:'Admissions Officer',
  Nurse:            'Nurse',
  Parent:           'Programme Manager',
};

export function getRoleLabel(role) {
  return ROLE_LABELS[role] || (role ? role.replace(/_/g, ' ') : 'Unknown');
}
